import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import config from "./config.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: sessionStorage.getItem("token") || "",
    menus: sessionStorage.getItem("menus") || ""
  },

  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  },

  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, menus) {
      state.status = "success";
      state.token = token;
      state.menus = menus;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.menus = "";
    }
  },
  actions: {
    login({ commit }, menus) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: config.API + "Token",
          data: menus,
          method: "POST"
        })
          .then(resp => {
            // console.log(resp.data.loggedInUserName);
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token, menus);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("menus");
            sessionStorage.removeItem("loggedInUserID");
            reject(err);
          });
      });
    },
    submit({ commit }, menus) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: config.API + "Token2",
          data: menus,
          method: "POST"
        })
          .then(resp => {
            // console.log(resp.data.loggedInUserName);
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token, menus);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("menus");
            sessionStorage.removeItem("loggedInUserID");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("menus");
        sessionStorage.removeItem("loggedInUserName");
        sessionStorage.removeItem("loggedInUserID");
        sessionStorage.removeItem("roles");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    }
  }
});
